import CryptoAES from 'crypto-js/aes';
import CryptoENC from 'crypto-js/enc-utf8';

export const getValue = (variavel = '') => CryptoAES.decrypt(
    variavel,
    process.env.REACT_APP_0
).toString(CryptoENC);